import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=ca74e40e&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=ca74e40e&lang=less&scoped=true&"
import style1 from "./bindPhone.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74e40e",
  null
  
)

export default component.exports